<template>
<div>
    
    <div>
    <el-card v-if="course != null" :body-style="{ padding: '0px' }" shadow="hover">
      <img v-if="course.imageUrl" class="card-image" :src="course.imageUrl" alt="">
      <img v-else class="card-image" src="@/assets/images/courseDefault.png" alt="">
    
    <div id="card-content" style="">
        <span v-if="course != null">{{course.name}}</span>
        <complete-porcent v-if="course != null" :courseId="course._id"></complete-porcent>
        <course-score v-if="course != null" :courseId="course._id"></course-score>
        <div class="bottom clearfix">
        <button-continue id="button" :courseId="course._id"></button-continue>
        </div>
    </div>
    </el-card>
   
    </div>
  </div>
</template>

<script>
import { getCourse } from '@/requests/courses'
import completePorcent from '@/components/courses/completePorcent'
import buttonContinue from '@/components/courses/buttonContinue'
import courseScore from '@/components/courses/courseScore'
export default {
  components: { completePorcent, courseScore, buttonContinue },
  props: [ 'courseId' ],
  data() {
    return {
      course: null,
      loading: false
    }
  },
  mounted() {
    this.loading = true
    getCourse({ id: this.courseId })
    .then((respuesta)=>{
      this.course = respuesta
      this.loading = false
    })
  }
}
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/components/wellcome/courseCard.vue